import React from "react"

import Paragraph from "../../../../design-system/paragraph"
import UniversalLink from "../../../../design-system/universal-link"
import * as styles from "./index.module.scss"

interface FooterLinkProps {
  text: React.ReactNode
  to: string
}

const FooterLink = ({ text, to }: FooterLinkProps) => (
  <UniversalLink to={to}>
    <Paragraph variant="3" className={styles.footerLink}>
      {text}
    </Paragraph>
  </UniversalLink>
)

export default FooterLink
